import "./OpenJobs.css";
import { Carousel } from "primereact/carousel";
import { useState, useEffect, useMemo } from "react";
import { ToggleButton } from "primereact/togglebutton";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from 'primereact/multiselect';
import { requestGetTalentsCatalog } from "../../services/wisdomServices/talentService";
import JobCard from "../../components/jobCard/JobCard";
import { departments } from "../../utils/helper/departments";
import { requestGetBoardJobs } from "../../services/wisdomServices/jobServices";


function OpenJobs(){
  const [loading, setLoading] = useState(false)
  const [jobTitle, setJobTitle] = useState('')
  const [openJobs, setOpenJobs] = useState([]);
  const [checked, setChecked] = useState(false);
  const [skills, setSkills] = useState([])
  const [selectedSkills, setSelectedSkills] = useState([])
  const [selectedDepartment, setSelectedDepartment] = useState("All Departments")
  const workTypes = [
    {value: "all", label:"All Types"},
    {value: "remote", label:"Remote"},
    {value: "on-site", label:"On-site"},
  ]
  const [selectedWorkType, setSelectedWorkType] = useState("all")
  const responsiveOptions = [
    {
      breakpoint: "1400px",
      numVisible: 3,
      numScroll: 1,
    },
    {
      breakpoint: "1024px",
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: "768px",
      numVisible: 1,
      numScroll: 1,
    },
  ];

  const filteredJobs = useMemo(() => {
    return openJobs.filter((job) => {

      const titleMatch =
        !jobTitle.trim() ||
        job.jobTitle?.toLowerCase().includes(jobTitle.toLowerCase().trim());


      const workTypeMatch =
        selectedWorkType === "all" ||
        job.location?.toLowerCase() === selectedWorkType;

      const departmentMatch =
        selectedDepartment === "All Departments" ||
        job.department === selectedDepartment;

      const jobSkills =
        job.skills?.split(",").map(s => s.trim().toLowerCase()) || [];

      const skillsMatch =
        !selectedSkills.length ||
        selectedSkills.some(skill =>
          jobSkills.includes(skill.toLowerCase())
        );

      return titleMatch && workTypeMatch && departmentMatch && skillsMatch;
    });

  }, [openJobs, jobTitle, selectedWorkType, selectedDepartment, selectedSkills]);

  const loadSkills = async() => {
    try {
      const skillsList = await requestGetTalentsCatalog("SKILL")
      setSkills(skillsList)
      
    } catch (error) {
      console.error("Error: ", error)
    }
  }

  const loadJobs = async() => {
    try {
      const jobList = await requestGetBoardJobs()
      setOpenJobs(jobList.data)
      
    } catch (error) {
      console.error("Error: ", error)
    }
  }

  
  useEffect(() => {
    const loadData = async () => {
        setLoading(true)
        await Promise.all([
            loadSkills(),
            loadJobs()
        ])
        setLoading(false)
    }

    loadData()
  }, [])

  const jobTemplate = (job) => {
    return (
      <JobCard
        job={job}
      />
    );
  };

  return(
    <div className="open-jobs-page">
      {/* HERO */}
      <header className="open-jobs-header">
        <div className="open-jobs-counter">
          <span><i className="pi pi-star-fill"></i> {openJobs.length} open positions</span>
        </div>
        <div className="open-jobs-header-title">
          <h1>Find Your Next <br /> Great Opportunity</h1>
          <p>Discover roles that match your skills and aspirations. <br />Apply in minutes and start your journey with us.</p>
        </div>
      </header>
      <main className="open-jobs-main-container">
        <section className="open-jobs-filters-section">
          <div>
            <h4>Open Positions</h4>
            <span>Swipe to explore all available roles</span>
          </div>
          <div>
            <ToggleButton 
              onLabel="Filters" 
              offLabel="Filters" 
              onIcon="pi pi-sliders-h" 
              offIcon="pi pi-sliders-h" 
              checked={checked} 
              onChange={(e) => setChecked(e.value)}
              className="filtersToggle" 
            />
          </div>
        </section>
        <section 
          className={`open-jobs-job-filters-container ${checked ? "filters-open" : ""}`}
        >
          <div className="card open-jobs-job-filters">
            <div className="p-inputgroup flex-column flex-1">
              <label htmlFor="form-compliance-id">Job Title</label>

              <div className="p-inputgroup">
                <span className="p-inputgroup-addon">
                  <i className="pi pi-search"></i>
                </span>
                <InputText
                  id="form-compliance-id"
                  value={jobTitle}
                  placeholder="Search titles..."
                  onChange={(e) => setJobTitle(e.target.value)}
                  style={{backgroundColor:"#FBFAF9", color:"black"}}
                />
              </div>
                      
            </div>

            <div className="p-inputgroup flex-column flex-1">
              <label htmlFor="form-compliance-user">Work Type</label>

              <div className="p-inputgroup">
                <Dropdown 
                  className="open-jobs-dropdowns"
                  options={workTypes}
                  value={selectedWorkType}
                  optionLabel="label"
                  optionValue="value"
                  onChange={(e) => setSelectedWorkType(e.value)}
                />
              </div>
                      
            </div>

            <div className="p-inputgroup flex-column flex-1">
              <label htmlFor="form-compliance-user">Department</label>

              <div className="p-inputgroup">
                <Dropdown
                  className="open-jobs-dropdowns"
                  options={departments}
                  value={selectedDepartment}
                  optionLabel="label"
                  optionValue="label"
                  onChange={(e) => setSelectedDepartment(e.value)}
                />
              </div>
                      
            </div>

            <div className="p-inputgroup flex-column flex-1">
              <label htmlFor="form-compliance-user">Skills</label>

              <div className="p-inputgroup">
                <MultiSelect 
                value={selectedSkills} 
                onChange={(e) => setSelectedSkills(e.value)} 
                options={skills} 
                optionLabel="value" 
                optionValue="value"
                display="chip" 
                placeholder="Filter by skills" 
                maxSelectedLabels={4} 
                className="w-full" />
              </div>
                      
            </div>
        </div>
        </section>
        <section className="open-jobs-carousel-section">
          <Carousel 
            value={filteredJobs}
            numVisible={3}
            numScroll={1}
            responsiveOptions={responsiveOptions}
            className="custom-carousel"
            circular={filteredJobs.length > 3}
            autoplayInterval={filteredJobs.length > 3 ? 5000 : 0}
            itemTemplate={jobTemplate}
          />
        </section>
      </main>
    </div>
  )
}

export default OpenJobs;